// Native
import { Badge, Box, FormatNumber, Grid, GridItem, Table, Text } from "@chakra-ui/react"
import moment from "moment"
import { useState } from "react"
import { useNavigate } from "react-router"

// Custom
import { Parts, UI } from "components"
import { Styles } from "config"
import useOrders from "hooks/useOrders"

export default function Vouchers(){

    const navigate = useNavigate()
    const [ page, setPage ] = useState(1)
    const orders = useOrders(page, null, 4)

    return(
    <>
    <UI.Header title="Vouchers" />

    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

        <GridItem><Parts.Widgets.Voucher.Activate /></GridItem>

        <GridItem><Parts.Widgets.Voucher.Resume /></GridItem>

        <GridItem>
            <Parts.Widgets.DownlineRegister h="auto" />
            <Parts.Widgets.Voucher.Store h="auto" mt={4} />
        </GridItem>

    </Grid>

    <Text children="Histórico de pedidos:" color="GrayText" my={4} />

    <Table.Root size="sm" variant="line" interactive>
        <Table.Header>
            <Table.Row>
            <Table.ColumnHeader>Código</Table.ColumnHeader>
            <Table.ColumnHeader>Status</Table.ColumnHeader>
            <Table.ColumnHeader>Total</Table.ColumnHeader>
            <Table.ColumnHeader>Data do pedido</Table.ColumnHeader>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            { orders.data?.data?.map(item => {
                const statusStyle = Styles.orderStatus(item.status)

                return(
                <Table.Row cursor="pointer" key={item.id} onClick={() => navigate(`/pedidos/${item.cod}`)}>
                    <Table.Cell>{item.cod} { item?.parent_order_id && <Badge size="sm" colorPalette="red">Pendência</Badge> }</Table.Cell>
                    <Table.Cell><Badge colorPalette={statusStyle.colorPalette}><UI.Icon name={statusStyle.icon} /> {statusStyle.label}</Badge></Table.Cell>
                    <Table.Cell><FormatNumber value={item.total_amount / 100} style="currency" currency="BRL" /></Table.Cell>
                    <Table.Cell>{moment(item.created_at).format('LLL')}</Table.Cell>
                </Table.Row>
                )
            }) }
        </Table.Body>
    </Table.Root>
    </>
    )
}
